import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import application from "./application";
import userTable from "./userTable";
import roleManager from "./roleManager";
import menuManager from "./menuManager";
import dictionary from "./dictionary";
import personPage from "./personPage";
Vue.use(Vuex);
//mutations types
export const SETERROR = "setError";
const state = {
  errorValue: ''
}
const mutations = {
  [SETERROR](state, data) {
    state.errorValue = data;
  },

};
export default new Vuex.Store({
  state,
  mutations,
  modules: {
    menuManager,
    roleManager,
    userTable,
    auth,
    htmlClass,
    config,
    breadcrumbs,
    application,
    dictionary,
    personPage,
  }
});
